<div (click)="appBackdropClose()" [ngClass]="{ 'appBackdrop':isAppBackdropVisible}"></div>
